import React, { Component } from 'react';

class PDFViewerV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
        };
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        this.loadBlobPdf();
    }

    async loadBlobPdf() {
        try {
            const blobUrl = this.props.pdfUrl;
            const disabledDownloadBtn = this.props?.disabledDownloadBtn || false;
            let hashString = '';
            if (navigator.userAgent.indexOf('iPhone') !== -1) {
                hashString += '#zoom=150';
            }

            // open local file in public dir
            // this.iframeRef.current.src = `/pdfjs/web/viewer.html?file=/sample.pdf${hashString}`; 
            this.iframeRef.current.src = `/pdfjs/web/viewer.html?file=${blobUrl}${hashString}`;

            // Wait for the iframe to load, then hide the download button
            this.iframeRef.current.onload = () => {
                const iframeDoc = this.iframeRef.current.contentDocument || this.iframeRef.current.contentWindow.document;
                if (iframeDoc) {
                    let style = iframeDoc.createElement("style");
                    let disabledIds = `#editorHighlightButton, #editorFreeTextButton, #editorInkButton, #editorStamp, #presentationMode, #secondaryOpenFile, #editorModeSeparator`;
                    if (disabledDownloadBtn) {
                        disabledIds += `, #downloadButton, #printButton, #secondaryDownload, #secondaryPrint, .verticalToolbarSeparator`;
                    }
                    style.innerHTML = disabledIds + `{ display: none !important; }`;
                    iframeDoc.head.appendChild(style);
                }
            };
        } catch (error) {
            console.error("error-pdf-viewerv2:", error);
        }
    }

    render() {
        return (<iframe ref={this.iframeRef} title="PDFJS Viewer" className="iframe-style" />);
    }
}

export default PDFViewerV2;